import React from 'react';
import PropTypes from 'prop-types';
import {ReactComponent as DefaultSort} from "../../assets/sort-default.svg";


function SortingIndicator({order}) {
    return (
        <div>
            <DefaultSort/>
        </div>
    );
}

SortingIndicator.propTypes = {};
SortingIndicator.defaultProps = {};

export default SortingIndicator;
